import React from 'react'
import { Bell } from 'ui/icons'
import { NotificationCircle } from 'ui/schedule'

function NotificationIcon ({ children, onClick }, ref) {
  return (
    <div className='relative w-4 h-4 cursor-pointer' ref={ref} onClick={onClick}>
      <Bell className='w-4 h-4' />
      <NotificationCircle>{children}</NotificationCircle>
    </div>
  )
}

export default React.forwardRef(NotificationIcon)
